import { ReactNode } from 'react';
import { Redirect } from 'react-router-dom';

import {
    OrganizationModuleType,
    isOrganizationModuleEnabled,
} from 'src/domain/organization';
import { isOrganizationAdministrator } from 'src/domain/user';
import { useCurrentOrganization } from 'src/view/hooks/useCurrentOrganization';
import { useSignedInUser } from 'src/view/hooks/useSignedInUser';
import { shouldOpenModuleSettings } from './moduleEntry';

type ModuleEntryRedirectProps = {
    children: ReactNode;
    moduleType: OrganizationModuleType;
    settingsPath: string;
};

export const ModuleEntryRedirect = ({
    children,
    moduleType,
    settingsPath,
}: ModuleEntryRedirectProps) => {
    const user = useSignedInUser();
    const { organizationId, organization } = useCurrentOrganization();
    const module = organization?.modules?.find(
        entry => entry.type === moduleType,
    );
    const openSettings = shouldOpenModuleSettings({
        enabled: isOrganizationModuleEnabled(organization, moduleType),
        isAdministrator: isOrganizationAdministrator(user, organizationId),
        isSupportMode: Boolean(user?.supportMode),
        memberIds: module?.memberIds,
    });

    return openSettings ? <Redirect to={settingsPath} /> : <>{children}</>;
};
